import { render, staticRenderFns } from "./AnnouncementsButton.vue?vue&type=template&id=46658417"
import script from "./AnnouncementsButton.vue?vue&type=script&lang=js"
export * from "./AnnouncementsButton.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsButton.vue?vue&type=style&index=0&id=46658417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports